import { render, staticRenderFns } from "./Companies.vue?vue&type=template&id=777bcc4d&scoped=true&"
import script from "./Companies.vue?vue&type=script&setup=true&lang=js&"
export * from "./Companies.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777bcc4d",
  null
  
)

export default component.exports